import { avgEngagementOnViewsHistoryConfig } from '@/lib/analytics/charts/tiktok/avgEngagementOnViewsHistory';
import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/tiktok/avgEngagementRateHistory';
import { bestTimeToPostConfig } from '@/lib/analytics/charts/tiktok/bestTimeToPost';
import { commentsHistoryConfig } from '@/lib/analytics/charts/tiktok/commentsHistory';
import { favoritesHistoryConfig } from '@/lib/analytics/charts/tiktok/favoritesHistory';
import { likesHistoryConfig } from '@/lib/analytics/charts/tiktok/likesHistory';
import { sharesHistoryConfig } from '@/lib/analytics/charts/tiktok/sharesHistory';
// Charts
import { avgCommentsReceivedPerPostConfig } from '@/lib/analytics/kpis/tiktok/avgCommentsPerVideo';
import { avgEngagementReachConfig } from '@/lib/analytics/kpis/tiktok/avgEngagementReach';
import { avgEngagementRateViewConfig } from '@/lib/analytics/kpis/tiktok/avgEngagementRate';
import { avgEngagementRatePerVideoConfig } from '@/lib/analytics/kpis/tiktok/avgEngagementRatePerVideo';
import { avgFavoritesPerVideoConfig } from '@/lib/analytics/kpis/tiktok/avgFavoritesPerVideo';
import { avgLikesReceivedConfig } from '@/lib/analytics/kpis/tiktok/avgLikesReceived';
import { avgSharesConfig } from '@/lib/analytics/kpis/tiktok/avgSharesPerVideo';
import { favoritesConfig } from '@/lib/analytics/kpis/tiktok/favoritesConfig';
import { totalCommentsReceivedConfig } from '@/lib/analytics/kpis/tiktok/totalComments';
import { totalEngagementConfig } from '@/lib/analytics/kpis/tiktok/totalEngagement';
import { tiktokLikeConfig } from '@/lib/analytics/kpis/tiktok/totalLikes';
import { totalSharesConfig } from '@/lib/analytics/kpis/tiktok/totalShares';
// kpis
import { mostEngagingVideosConfig } from '@/lib/analytics/widget/tiktok/export/mostEngagingVideosConfig';
// Widgets
import { SIZE_25, SIZE_33, SIZE_50, SIZE_FULL } from '@/lib/gridElements/size';

export const EngagementTiktok = [
    // line 1
    { ...totalEngagementConfig, size: SIZE_25 },
    { ...avgEngagementRatePerVideoConfig, size: SIZE_25 },
    { ...avgEngagementRateViewConfig, size: SIZE_25 },
    { ...avgEngagementReachConfig, size: SIZE_25 },
    //line 2
    { ...avgEngagementRateHistoryConfig, size: SIZE_50 },
    { ...avgEngagementOnViewsHistoryConfig, size: SIZE_50 },
    // line 3
    { ...mostEngagingVideosConfig, size: SIZE_FULL },
    // line 4
    { ...tiktokLikeConfig, size: SIZE_25 },
    { ...avgLikesReceivedConfig, size: SIZE_25 },
    { ...totalCommentsReceivedConfig, size: SIZE_25 },
    { ...avgCommentsReceivedPerPostConfig, size: SIZE_25 },
    //line 5
    { ...likesHistoryConfig, size: SIZE_50 },
    { ...commentsHistoryConfig, size: SIZE_50 },
    // line 6
    { ...favoritesConfig, size: SIZE_25 },
    { ...avgFavoritesPerVideoConfig, size: SIZE_25 },
    { ...totalSharesConfig, size: SIZE_25 },
    { ...avgSharesConfig, size: SIZE_25 },
    // line 7
    { ...favoritesHistoryConfig, size: SIZE_50 },
    { ...sharesHistoryConfig, size: SIZE_50 },
    // line 8
    { ...bestTimeToPostConfig, size: SIZE_FULL, defaultFilter: 'engagement_rate' }
];

export const requestTiktokParams = [
    // TiktokMedia
    [
        'engagement',
        'average_engagement_rate_per_views',
        'average_engagement_on_reach_per_video',
        'views',
        'average_views_per_video',
        'likes',
        'average_likes_per_video',
        'video_views_history',
        'likes_history',
        'average_engagement_rate_per_video',
        'average_views_rate_per_video',
        'favorites',
        'average_favorites_per_video'
    ],
    [
        'best_time_to_post',
        'comments',
        'average_comments_per_video',
        'shares',
        'average_shares_per_video',
        'comments_history',
        'shares_history',
        'average_engagement_rate_history',
        'average_engagement_on_views_history',
        'favorites_history'
    ]
];

export const requestTiktokOtherParameters = {
    best_time_to_post: {
        type: bestTimeToPostConfig.defaultFilter ?? 'video_views'
    }
};
